export default "__VITE_ASSET__BdbFDYDC__"